import React from 'react';
import { Provider } from 'react-redux';
import Application from 'application/components/Application';

import 'shared-styles/typography.css';

const Root = ({ store }) =>
  <Provider store={store}>
    <Application />
  </Provider>;

export default Root;



// WEBPACK FOOTER //
// ./src/root/Root.js